import {AppLanguage} from './app-language.model';

export enum OrderStatus {
  Approved = 0,
  Requested = 1,
  Rejected = 2
}

export interface OrderStatusStyle {
  backgroundColor: string;
  color: string;
}

export const ORDER_STATUS_LABELS: Record<AppLanguage, Record<OrderStatus, string>> = {
  mk: {
    [OrderStatus.Approved]: 'Одобрено',
    [OrderStatus.Requested]: 'Испратено',
    [OrderStatus.Rejected]: 'Одбиено'
  },
  en: {
    [OrderStatus.Approved]: 'Approved',
    [OrderStatus.Requested]: 'Requested',
    [OrderStatus.Rejected]: 'Rejected'
  }
};

export function getOrderStatusLabel(status: OrderStatus, language: AppLanguage = 'mk'): string {
  return ORDER_STATUS_LABELS[language]?.[status] ?? OrderStatus[status] ?? '';
}

export function getOrderStatusStyle(status: OrderStatus): OrderStatusStyle {
  switch (status) {
    case OrderStatus.Requested:
      return { backgroundColor: 'rgba(13, 110, 253, 0.15)', color: '#0d6efd' };
    case OrderStatus.Rejected:
      return { backgroundColor: 'rgba(220, 53, 69, 0.15)', color: '#dc3545' };
    default:
      return { backgroundColor: 'rgba(25, 135, 84, 0.15)', color: '#198754' };
  }
}
